// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__HdBiq","selected":"styles_selected__19_ix"};